import { render, staticRenderFns } from "./wordLimit.vue?vue&type=template&id=3a3fd00b&scoped=true&"
import script from "./wordLimit.vue?vue&type=script&lang=js&"
export * from "./wordLimit.vue?vue&type=script&lang=js&"
import style0 from "./wordLimit.vue?vue&type=style&index=0&id=3a3fd00b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3fd00b",
  null
  
)

export default component.exports